import {
  type UserOrderResponseV2,
  UserSubOrder1EnrichedStatusEnum,
  type UserSubOrderV2,
} from '@redteclab/api/clients/bully'

import { type PublicGlobalConfig } from '../../../../../global-config'
import {
  userSubOrderAccessorIsDamagedProductClaimable,
  userSubOrderAccessorIsMarketplaceOrder,
} from '../../../../../order/'
import {
  urlResolverGetAccountSubOrderDetailBySubOrderIdDamagedProducts,
  urlResolverGetOrderQuestionsReportDamagedProductPage,
  urlResolverGetReportOrderIncident,
} from '../../../../../url-handling'

export const orderQuestionSelfServiceAccessorGetSubOrderDetailDamagedProductUrl =
  ({
    canOpenIncident = false,
    config,
    order,
    subOrder,
  }: {
    canOpenIncident?: boolean
    config: PublicGlobalConfig
    order: UserOrderResponseV2
    subOrder: UserSubOrderV2
  }): string | undefined => {
    const isClaimable = userSubOrderAccessorIsDamagedProductClaimable(subOrder)
    const isMarketplace = userSubOrderAccessorIsMarketplaceOrder(subOrder)

    const { orderMasterData } = order
    const { enrichedStatus, subOrderId } = subOrder

    if (!subOrderId || !orderMasterData?.orderNumber) {
      return undefined
    }

    if (
      canOpenIncident &&
      isMarketplace &&
      enrichedStatus === UserSubOrder1EnrichedStatusEnum.Dispatched
    ) {
      return urlResolverGetReportOrderIncident(
        config,
        orderMasterData.orderNumber,
        subOrderId,
      )
    }

    if (isClaimable) {
      return urlResolverGetAccountSubOrderDetailBySubOrderIdDamagedProducts({
        config,
        fromFragenBestellung: true,
        orderId: orderMasterData.orderNumber,
        subOrderId,
      })
    }

    return urlResolverGetOrderQuestionsReportDamagedProductPage(
      config,
      orderMasterData.orderNumber,
      subOrderId,
    )
  }
